module.exports = __webpack_public_path__ + "i18n/es.55413c8bc2364ab891d36bc042398672.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 998
// module chunks = 60